/* eslint eqeqeq: "off" */
import { Field, Form, Formik } from "formik";
import moment from "moment";
import React, { useEffect } from "react";
import { shallowEqual, useSelector } from "react-redux";
import * as Yup from "yup";
import { yupNumber } from "../../../../helpers/yupNumber";
import { Input, Select } from "../../../../../_metronic/_partials/controls";
import { useProgramContext } from "./ProgramDataContext";

// Validation schema
const SchoolProgramEditSchema = Yup.object().shape({
  startdate: Yup.date().required("Start Date is required"),
  enddate: Yup.date()
    .required("End Date is required")
    .test("is-greater", "end date should be greater", function(value) {
      const { startdate } = this.parent;
      return moment(value, "yyyy-mm-dd").isAfter(
        moment(startdate, "yyyy-mm-dd").subtract(1, "days")
      );
    }),
  day: Yup.string().required(),
  start_time: Yup.string().required("Start time is required"),
  end_time: Yup.string()
    .required("End time cannot be empty")
    .test("is-greater", "end time should be greater", function(value) {
      const { start_time } = this.parent;
      return moment(value, "hh:mm").isAfter(moment(start_time, "hh:mm"));
    }),
  sessions: yupNumber()
    .min(1, "1 is minimum")
    .max(100, "20 is maximum")
    .required("Sessions is required"),
  maximum_student: yupNumber()
    .min(1, "1 is minimum")
    .max(100, "100 is maximum")
    .required("Max Students is required"),
  program_type_id: Yup.string().required("Program Type is required"),
  active_id: Yup.string().required("Active status is required"),
  school_type_id: Yup.string().required("School Type is required"),
  delivery_type_id: Yup.string().required("Delivery Type is required"),
  school_information_id: Yup.string().required(
    "School Information is required"
  ),
  class_full_ind: Yup.string(),
  web_register_ind: Yup.string(),
});

export function ProgramEditForm({ 
  schoolProgram, 
  btnRef, 
  saveSchoolProgram,  
}) {
  const access = useSelector((state) => state.auth.access, shallowEqual);
  const DROPDOWN_TYPE = useProgramContext().TYPES;

  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={schoolProgram}
        validationSchema={SchoolProgramEditSchema}
        onSubmit={(values) => {
          saveSchoolProgram(values);
        }}
      >
        {({ handleSubmit, values, setFieldValue }) => (
          <>
            
            <Form className="form form-label-right">
              <div className="form-group row">
                <div className="col-lg-3">
                  <Select name={`program_type_id`} label="Program Type">
                    {DROPDOWN_TYPE.PROGRAM_TYPE &&
                      DROPDOWN_TYPE.PROGRAM_TYPE.map((a) => (
                        <option
                          key={a.id}
                          disabled={values.school_program_id ? true : false}
                          value={a.id}
                        >
                          {a.value}
                        </option>
                      ))}
                  </Select>
                </div>
                <div className="col-lg-3">
                  <Select name={`school_type_id`} label="School Program Type">
                    {DROPDOWN_TYPE.BATCH_TYPE &&
                      DROPDOWN_TYPE.BATCH_TYPE.map((a) => (
                        <option key={a.id} value={a.id}>
                          {a.value}
                        </option>
                      ))}
                  </Select>
                </div>

                <div className="col-lg-3">
                  <Select name={`active_id`} label="Program Status">
                    <option value="1">Active</option>
                    <option value="0">Inactive</option>
                  </Select>
                </div>
                <div className="col-lg-3">
                  <Select name={`delivery_type_id`} label="Delivery Type">
                    {DROPDOWN_TYPE.DELIVERY_TYPE &&
                      DROPDOWN_TYPE.DELIVERY_TYPE.map((a) => (
                        <option key={a.id} value={a.id}>
                          {a.value}
                        </option>
                      ))}
                  </Select>
                </div>
              </div>

              <div className="form-group row">
                <div className="col-lg-3">
                  <Select
                    name={`school_information_id`}
                    label="School Information"
                  >
                    <option value="">-- Select School --</option>
                    {DROPDOWN_TYPE.SCHOOL_INFORMATION &&
                      DROPDOWN_TYPE.SCHOOL_INFORMATION.map((a) => (
                        <option key={a.id} value={a.id}>
                          {a.value}
                        </option>
                      ))}
                  </Select>
                </div>
                <div className="col-lg-3">
                  <label className={"required-field"}>
                    Enter Number of sesssions
                  </label>
                  <Field
                    name={`sessions`}
                    component={Input}
                    placeholder="Number of sessions "
                    type="number"
                  />
                </div>
                <div className="col-lg-3">
                  <Select name={`class_full_ind`} label="Class Full?">
                    <option value="0">Not Full</option>
                    <option value="1">Full</option>
                  </Select>
                </div>
                <div className="col-lg-3">
                  <label className={"required-field"}>
                    Enter Maximum Student Count
                  </label>
                  <Field
                    name={`maximum_student`}
                    component={Input}
                    placeholder="Maximum Student Count"
                    type="number"
                  />
                </div>
              </div>

              <div className="form-group row">
                <div className="col-lg-4">
                  <Select name="day" label="Day">
                    {DROPDOWN_TYPE.DAYS &&
                      DROPDOWN_TYPE.DAYS.map((a) => (
                        <option key={a} value={a}>
                          {a}
                        </option>
                      ))}
                  </Select>
                </div>
                <div className="col-lg-4">
                  <label className={"required-field"}>Enter Start Date</label>
                  <Field
                    name={`startdate`}
                    component={Input}
                    type="date"
                    value={
                      values.startdate ? values.startdate.split("T")[0] : ""
                    }
                  />
                </div>
                <div className="col-lg-4">
                  <label className={"required-field"}>Enter End Date</label>
                  <Field
                    name={`enddate`}
                    component={Input}
                    type="date"
                    value={values.enddate ? values.enddate.split("T")[0] : ""}
                  />
                </div>
              </div>

              <div className="form-group row">
                <div className="col-lg-6">
                  <label className={"required-field"}>Start Time</label>
                  <Field
                    name={`start_time`}
                    component={Input}
                    type="time"
                    value={values.start_time}
                  />
                </div>
                <div className="col-lg-6">
                  <label className={"required-field"}>End Time</label>
                  <Field
                    name={`end_time`}
                    component={Input}
                    type="time"
                    value={values.end_time}
                  />
                </div>
              </div>

              {/* Last field on the form. Off = the website lists the program
                  contact-only; on = the website may sell it when a price
                  resolves and the class isn't full. */}
              <div className="form-group row">
                <div className="col-lg-3">
                  <Select name={`web_register_ind`} label="Register on Website?">
                    <option value="0">No (contact only)</option>
                    <option value="1">Yes</option>
                  </Select>
                </div>
              </div>

              <button
                type="submit"
                style={{ display: "none" }}
                ref={btnRef}
                onSubmit={() => handleSubmit()}
              ></button>
            </Form>
          </>
        )}
      </Formik>
    </>
  );
}